import React from "react";
import { ScheduleReserveDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { MyBookingUpCommingWidget } from "widgets";
import { Headers, Cards, Displays, Buttons, Navigations } from "components";

class ScheduleReserveDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { id } = this.props.router.params;
    if (id === "room") {
      this.setState({
        data: {
          type: "2",
          // name: "Music Practice Room",
          name_en: "Music Practice Room",
          name_th: "ห้องซ้อมดนตรี",
          // description: "Music Practice Room",
          address_en:
            "Siam Pathumwan House, Floor M, Unit 414,Siam Pathumwan House, Floor M, Unit 414, Rama I Road, Wang Mai Subdistrict, Pathum Wan District, Bangkok 10330",
          address_th:
            "อาคารสยามปทุมวัน เฮ้าส์, ชั้น M 414 ถนนพระรามที่ 1 แขวงวังใหม่ เขตปทุมวัน กรุงเทพฯ 10330",
          description_en:
            "The Music Practice Room at Yamaha Music School is designed as a cozy space where everyone can enjoy practicing, with both grand and acoustic pianos available, along with additional multi-function rooms.",
          description_th:
            "ห้องซ้อมดนตรีที่โรงเรียนดนตรียามาฮ่า (อาคารสยามปทุมวัน เฮ้าส์) ได้รับการออกแบบให้มี บรรยากาศอบอุ่น เป็นกันเอง เหมาะสำหรับทั้งการเรียนและการฝึกซ้อม พร้อมเปียโนแกรนด์ และอะคูสติก รวมถึงห้องอเนกประสงค์ และเดินทางได้สะดวก",
          google_map_url: "https://maps.app.goo.gl/MdX6PTCQxcGyWwuE9",
        },
        isLoading: false,
      });
    } else {
      let resArr = await Promise.all([
        userService.GET_ROOM_DETAIL(id),
        // userService.GET_ROOM_REC_LIST(`?exclude_id=${id}&limit=1`),
      ]);
      if (resArr) {
        this.setState({
          data: resArr[0].data,
          // dataRec: resArr[1].data,
          isLoading: false,
        });
      }
    }
  };

  // เปิด popup แจ้งชำระเงินจากลิงก์อีเมลแล้ว ลบ booking_id ออกจาก url (กันรีเฟรชแล้วเด้งซ้ำ)
  handleAutoOpenedPayment = () => {
    const { router } = this.props;
    router.navigate(router.location.pathname, { replace: true });
  };

  handleMusicHallBooking = () => {
    const { id } = this.props.router.params;
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_HALL}/${id}/booking/1`);
  };

  handleClickMusicPracticeRoomViewmore = () => {
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`);
  };

  render() {
    const { t, router } = this.props;
    const { id } = router.params;
    const {
      isLoading,
      data,
      // dataRec
    } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      id === "room"
        ? {
            name: t("Music Practice Room", { ns: "common" }),
          }
        : {
            name: t("Music Hall Bangkok", { ns: "common" }),
          },
    ];
    return (
      <ScheduleReserveDetailContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_hall_and_practice_detail_container">
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <>
              <div className="header_layout">
                {data.type === "1" ? (
                  <Headers.NewPageHeader
                    title={"YAMAHA MUSIC  HALL, BANGKOK"}
                    sub_title={"& Music Practice room"}
                  />
                ) : (
                  <Headers.NewPageHeader
                    title={"MUSIC PRACTICE ROOM"}
                    sub_title={"ห้องซ้อมดนตรี"}
                  />
                )}
              </div>
              <div className="musicpractice_layout">
                <Cards.MusicPracticeRoom
                  {...data}
                  banner_img={
                    data.type === "1"
                      ? "/assets/images/backgrounds/MusicPracticeRoom.jpg"
                      : "/assets/images/backgrounds/room.jpg"
                  }
                />
              </div>
              {/* {dataRec && dataRec.length > 0 && (
              <>
                <div className="upcoming_event_layout">
                  {t("Upcoming  Event", { ns: "room" })}
                </div>
                <div className="upcoming_layout">
                  <Cards.UpcomingEvent {...dataRec[0]} />
                </div>
              </>
            )}  */}
              <div className="address_info_layout">
                <Displays.AddressInfo {...data} />
              </div>
              {data.type === "1" && (
                <>
                  <div className="interesting_layout">
                    <Buttons.BtnArrowRight
                      theme_text_center
                      label={t("Interesting to Rent", { ns: "room" })}
                      onClick={this.handleMusicHallBooking}
                    />
                  </div>
                </>
              )}
              {/* ห้องซ้อมเหลือปุ่มเดียว เข้าหน้ารายละเอียดห้อง แล้วเลือกห้อง/จองต่อจากหน้านั้น */}
              {data.type === "2" && (
                <div className="practice_room_btn_layout">
                  {/* ชื่อปุ่มยาว จอแคบอาจตกบรรทัด ให้ความสูงยืดตามข้อความแทนค่าคงที่ 48px */}
                  <Buttons.BtnArrowRight
                    theme_text_center
                    height="auto"
                    label={t("Music Practice Room Details & Booking Request", {
                      ns: "room",
                    })}
                    onClick={this.handleClickMusicPracticeRoomViewmore}
                  />
                </div>
              )}
              <MyBookingUpCommingWidget
                room_type={data?.type}
                autoOpenPaymentBookingId={
                  queryString.parse(router.location.search).booking_id
                }
                onAutoOpenedPayment={this.handleAutoOpenedPayment}
              />
            </>
          )}
        </div>
      </ScheduleReserveDetailContainerStyled>
    );
  }
}

export default withTranslation(["common", "news", "room"])(
  withRouter(ScheduleReserveDetailContainer),
);
